export const COLUMN_IDS = {
  RANK: 'rank',
  COMPANY: 'similarOrganizationName',
  SIMILARITY_SCORE: 'similarityScore',
  INDUSTRY: 'INDUSTRY',
  COMPANY_SIZE: 'COMPANY_SIZE',
  INVESTMENT_TYPE: 'INVESTMENT_TYPE',
  INTERNATIONAL_TRADE: 'INTERNATIONAL_TRADE',
}

export const getLocalizedValue = (data, key, locale) => {
  const viKey = `${key}Vi`
  return locale === 'vi' ? data?.[viKey] || data?.[key] : data?.[key]
}

export const normalizePublicDate = (value) => {
  const stringValue = String(value || '')
  if (/^\d{8}$/.test(stringValue)) {
    return `${stringValue.slice(0, 4)}-${stringValue.slice(
      4,
      6,
    )}-${stringValue.slice(6, 8)}`
  }
  return value
}
